<template>
  <div class="">
    <textarea :id="id" :class="{ hidden: loading }" />
    <textarea v-if="editMode" :value="content" />
  </div>
</template>

<script lang="ts" setup>
import 'suneditor/dist/css/suneditor.min.css'
import suneditor from 'suneditor'

import plugins from 'suneditor/src/plugins'
import type SunEditor from 'suneditor/src/lib/core'

const editMode = false

const props = defineProps<{ value: string }>()
const propsValue = toRef(props, 'value')
const details = ref<string>(props.value)
const loading = ref(true)

const content = computed(() => details.value)

const id = useId()

watch(propsValue, (nextValue) => {
  editor.setContents(nextValue)
})

let editor: SunEditor

onMounted(() => {
  editor = suneditor.create(id, {
    plugins: plugins,
    hideToolbar: true,
    resizingBar: false,
    resizeEnable: false,
    width: '100%',
    height: '100%',
    value: details.value,
    font: ['CabinetGrotesk-Variable', 'Anuphan'],
    mode: 'inline',
    buttonList: [
      ['font'],
      ['undo', 'redo'],
      ['formatBlock'],
      ['bold', 'list', 'align'],
      ['link', 'image'],
      ['showBlocks', 'fullScreen', 'preview', 'print']
    ]
  })
  editor.onChange = function (contents) {
    details.value = contents
  }
  editor.readOnly(!editMode)
  !editMode && editor.wysiwyg.disable()
})
</script>

<style lang="scss">
.sun-editor {
  border: none !important;
  background-color: transparent !important;
}
.se-wrapper {
  h1,
  h1 > span {
    font-size: 48px !important;
    line-height: 62.4px !important;
    margin-bottom: 48px !important;

    @media screen and (max-width: 768px) {
      font-size: 32px !important;
      line-height: 48px !important;
    }
    &:not(:first-child) {
      margin-top: 48px !important;
      line-height: 62.4px !important;
    }
    &:first-child {
      margin-top: 0px !important;
    }
  }
  h2,
  h2 > span {
    font-size: 20px !important;
    margin-bottom: 32px !important;

    &:not(:first-child) {
      margin-top: 32px !important;
    }
    &:first-child {
      margin-top: 0px !important;
    }
  }
  p,
  p > span,
  li,
  li > span,
  a,
  a > span {
    font-size: 16px !important;
    color: #000 !important;
  }
  a {
    text-decoration: underline;
  }
}
.sun-editor-editable {
  padding: 0 !important;
  background-color: transparent !important;
}
.se-image-container {
  outline: none !important;
}

.se-toolbar {
  z-index: 1000 !important;
}
</style>
